import { message } from "antd";

import { setLocalStorage } from "../utils/localStorage";
import { LOGIN, REGISTER, FORGOT_PASSWORD } from "../constants/url";

import { catchErrors } from "../utils/catchErrors";
import { genericApiCall } from "../utils/servicesBaseUtil";
import { getEncodedParams } from "../utils/generateFormData";

export const loginApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = LOGIN;
    let formData = getEncodedParams(data);
    genericApiCall({
      url: url,
      method: "POST",
      data: formData,
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          //   dispatch(storeToken(responseJson?.data?.token));
          setLocalStorage("alrounderToken", responseJson?.data?.token);
          successCallback();
        } else {
          message.error(responseJson?.message);
          localStorage.clear();
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const registerApi = ({ data, finalCallback, successCallback, failureCallback }) => {
  return dispatch => {
    let url = REGISTER;
    let formData = getEncodedParams(data);
    genericApiCall({
      url: url,
      method: "POST",
      data: formData
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          setLocalStorage("alrounderToken", responseJson?.data?.token);
          successCallback();
        } else {
          failureCallback(responseJson?.data)
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        catchErrors(error, url)
      })
      .finally(() => {
        finalCallback()
      })
  }
}

export const forgotPasswordApi = ({ data, successCallback, finalCallback }) => {
  return dispatch => {
    let url = FORGOT_PASSWORD;
    let formData = getEncodedParams(data);
    genericApiCall({
      url: url,
      method: "POST",
      data: formData
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback();
        } else {
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        catchErrors(error, url)
      })
      .finally(() => {
        finalCallback()
      })
  }
}